'use client';

import React from 'react';
import { Link } from '../../utils/router';
import { useCompare } from '../../context/CompareContext';
import './ProductCard.css';

const categoryNames = {
  food: '飼料/零食',
  toys: '玩具',
  accessories: '用品配件',
  clothing: '服飾',
  cage: '籠子/窩',
  feeder: '餵食器具',
  others: '其他',
};

const FALLBACK_IMG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' fill='%23f0f0f0'%3E%3Crect width='400' height='300'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23ccc' font-size='20'%3EPuiPi%3C/text%3E%3C/svg%3E";

const ProductCard = ({ product, priority = false }) => {
  const imageUrl = product.images?.[0] || FALLBACK_IMG;
  const { addToCompare, removeFromCompare, isInCompare } = useCompare();
  const inCompare = isInCompare(product._id);

  const handleCompareClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (inCompare) {
      removeFromCompare(product._id);
    } else {
      addToCompare(product);
    }
  };

  return (
    <Link to={`/product/${product._id}`} className="product-card">
      <div className="product-image-wrapper">
        <img
          src={imageUrl}
          alt={product.title}
          className="product-image"
          loading={priority ? 'eager' : 'lazy'}
          fetchPriority={priority ? 'high' : 'auto'}
          width="400"
          height="300"
          onError={(e) => { e.target.src = FALLBACK_IMG; }}
        />
        <span className="product-condition-badge">{product.condition}</span>
        <button
          className={`product-compare-btn ${inCompare ? 'product-compare-btn--active' : ''}`}
          onClick={handleCompareClick}
          aria-label="比較"
          data-testid={`compare-btn-${product._id}`}
          title={inCompare ? '取消比較' : '加入比較'}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <line x1="18" y1="20" x2="18" y2="10" />
            <line x1="12" y1="20" x2="12" y2="4" />
            <line x1="6" y1="20" x2="6" y2="14" />
          </svg>
        </button>
      </div>
      <div className="product-info">
        <div className="product-tags">
          <span className="product-category-tag">{categoryNames[product.category] || '其他'}</span>
        </div>
        <h3 className="product-title">{product.title}</h3>
        <p className="product-desc">{product.description}</p>
        <div className="product-bottom">
          <span className="product-price">NT$ {product.price?.toLocaleString()}</span>
          <span className="product-location">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            {product.location}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
